import * as Yup from 'yup';

export const ResolvableMissionTypeTemplatesSchema = Yup.object().shape({
  reportTemplateIds: Yup.array()
    .of(Yup.string().required())
    .optional()
    .nullable()
    .default(undefined),
  quotationTemplateId: Yup.string().optional().nullable().default(undefined),
});
